import { FormatDateOptions } from "@formatjs/intl";

const MIN_TIMESTAMP = new Date("2010-01-01").getTime();

export const useDateTimeFormatter = (timestamp: number) => {
  if (
    !timestamp ||
    timestamp < 0 ||
    typeof timestamp !== "number" ||
    timestamp < MIN_TIMESTAMP ||
    isNaN(timestamp)
  )
    return "N/A";

  const date = new Date(timestamp);

  const now = new Date(); // Current date and time
  const diff = date.getTime() - now.getTime(); // Difference in milliseconds
  const daysDiff = Math.ceil(diff / (1000 * 60 * 60 * 24)); // Difference in days

  if (daysDiff === 0) {
    // Today
    return `Today at ${date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    })}`;
  } else if (daysDiff === 1) {
    // Tomorrow
    return `Tomorrow at ${date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    })}`;
  } else if (daysDiff > 1 && daysDiff < 7) {
    // Next X day
    return `Next ${date.toLocaleDateString("en-US", {
      weekday: "long",
    })} at ${date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    })}`;
  } else if (daysDiff < 0 && daysDiff > -7) {
    // Last X day
    return `Last ${date.toLocaleDateString("en-US", {
      weekday: "long",
    })} at ${date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    })}`;
  } else {
    // Specific date with day ordinal suffix
    const suffixes = ["th", "st", "nd", "rd"];
    const day = date.getDate();
    const suffix =
      day % 10 < 4 && (day % 100 < 10 || day % 100 > 20)
        ? suffixes[day % 10]
        : suffixes[0];

    const timeString = date
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })
      .replace(" AM", "am")
      .replace(" PM", "pm");
    return `${date.toLocaleDateString("en-US", {
      weekday: "long",
    })} the ${day}${suffix} at ${timeString}`;
  }
};
